import React from 'react';
import ReactDOM from 'react-dom';
import DataDisplay from './DataDisplay'
import DataTable from './DataTable'
import { Grid } from 'semantic-ui-react'
import store from './store'
import { Provider } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from './utilities.js';

import 'semantic-ui-css/semantic.min.css'

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column width={1} />
          <Grid.Column width={14}>
            <DataDisplay />
          </Grid.Column>
          <Grid.Column width={1} />
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={1} />
          <Grid.Column width={14}>
            <DataTable />
          </Grid.Column>
          <Grid.Column width={1} />
        </Grid.Row>
      </Grid>
    </Provider>
  </ThemeProvider>,
  document.getElementById('root')
);
